import { useIntl } from "react-intl";

const useTraduction = () => {
    const intl = useIntl();
    return {
        t: id => intl.formatMessage({ id }),
    } 
};

export { useTraduction };